import {createRouter, createWebHistory} from 'vue-router'
import {afterEach} from './after-each.guards'
import {ArticleRoutes} from './article.routes'
import {beforeEach} from './before-each.guards'
import {HelpRoutes} from './help.routes'
import {HuntRoutes} from './hunt.routes'
import {IndexRoutes} from './index.routes'
import {RecycleRoutes} from './recycle.routes'
import {RepairRoutes} from './repair.routes'
import {StandardRoutes} from './standard.routes'
import {ToolRoutes} from './tool.routes'
import {Wholesale2Routes} from './wholesale2.routes'
import {WorkingBoardRoutes} from './working-board.route'

// router
const router = createRouter({
  history: createWebHistory(''),
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        el: to.hash,
      }
    }
    else {
      return savedPosition || {
        top: 0,
        left: 0,
      }
    }
  },
  routes: [
    ...IndexRoutes,
    ...ArticleRoutes,
    ...StandardRoutes,
    ...Wholesale2Routes,
    ...RecycleRoutes,
    ...WorkingBoardRoutes,
    ...RepairRoutes,
    ...HuntRoutes,
    ...HelpRoutes,
    ...ToolRoutes,
    {
      path: '/:catchAll(.*)*',
      redirect: () => {
        return {
          name: 'Index',
        }
      },
    },
  ],
})

router.beforeEach(beforeEach)
router.afterEach(afterEach)

export {router}
